import { format } from 'date-fns';
import {
  useEffect,
} from 'react';

import { useWidgetState } from './use-widget-state';

/**
 * A custom hook for Single Date tab type
 * @returns {CustomTabState} a map of state and state update functions for all `Single ` tabs
 */
export const useSingleDate = ({
  commerceEngineUrl,
}) => {
  const {
    tabValues,
    setTabValues,
    buttonLink,
    setButtonLink,
  } = useWidgetState();
  const components = [{
    name: 'single_date',
    type: 'datepicker',
    ariaLabel: 'Select date',
    isDefaultDate: false,
    placeholder: 'Select Date',
    isCurrentDaySelectable: true,
    maxDaysToBookAhead: 550,
    prettyDate: 'MMM dd yyyy',
    dateFormat: 'MM/dd/yyyy',
  }];

  useEffect(() => {
    if (tabValues[components[0].name]) {
      const { minDate, selectedDate } = tabValues[components[0].name];

      setButtonLink(`${commerceEngineUrl}${format(selectedDate || minDate, 'yyyy-MM-dd')}`);
    }
  }, [tabValues]);

  return {
    setTabValues,
    buttonLink,
    components,
  };
};

/**
 * A custom hook for Link Selector tab type (can also handle button only tabs)
 * @returns {CustomTabState} a map of state and state update functions for all `Link Selector` tabs
 */
export const useLinkSelector = ({
  commerceEngineUrl,
  dropdownOptions,
  selectableItemType,
}) => {
  const {
    tabValues,
    setTabValues,
    buttonLink,
    setButtonLink,
  } = useWidgetState();
  const components = (dropdownOptions?.length > 0)
    ? [
      {
        name: 'single_item_date',
        ariaLabel: 'Select item',
        type: selectableItemType || 'select',
        isHideLabel: true,
        placeholder: 'Select an option...',
        choices: dropdownOptions
          .map((option) => ({ label: option.buttonText, value: option.buttonLink })),
      },
    ]
    : [];

  useEffect(() => {
    if (tabValues?.[components[0]?.name]?.value || components.length === 0) {
      setButtonLink(`${(commerceEngineUrl || '')}${tabValues?.[components[0]?.name]?.value || ''}`);
    }
  }, [tabValues]);

  return {
    setTabValues,
    buttonLink,
    components,
  };
};
